<template>
  <div>
    <svg-icon type="mdi" :path="getIcon" :size="size" />
  </div>
</template>

<script>
  import SvgIcon from '@jamescoyle/vue-icon'
  //
  import { 
    mdiSitemap,
    mdiShieldHalfFull,
    mdiLan,
    mdiSealVariant,
    mdiAccountGroup,
    mdiFacebook,
    mdiTwitter,
    mdiInstagram,
    mdiSendCircle,
    mdiWhatsapp,
    mdiYoutube,
    mdiSearchWeb,
    mdiMenu,
    mdiSoccer,
    mdiStore,
    mdiLoginVariant,
    mdiTournament,
    mdiTrophy,
    mdiGoogleMaps,
    mdiTrophyAward,
    mdiNewspaper,
    mdiCalendar,
    mdiSoccerField,
    mdiOrderNumericDescending,
    mdiContentCopy,
    mdiTimerOutline,
    mdiTrophyOutline,
    mdiHomeCircleOutline,
    mdiShieldOutline,
    mdiLaptop,
    mdiCash,
    mdiToggleSwitchOffOutline,
    mdiCalendarEnd,
    mdiClockOutline,
    mdiCalendarStar,
    mdiInformationOutline,
    mdiCloseCircleOutline,
    mdiSettingsHelper,
    mdiChevronDownBoxOutline,
    mdiScoreboardOutline,
    mdiArrowRightThick,
    mdiArrowLeftThick,
    mdiSquare,
    mdiWhistle,
    mdiGenderMaleFemaleVariant,
    mdiCalendarLock,
    mdiCalendarToday,
    mdiGoogle,
    mdiLock,
    mdiEmail,
    mdiFormSelect,
    mdiCardAccountDetails,
    mdiPlus,
    mdiNewspaperVariantOutline,
    mdiBookEditOutline,
    mdiWeb,
    mdiTableCog,
    mdiTableCheck,
    mdiContentSave,
    mdiDelete,
    mdiTshirtCrew,
    mdiRectangle,
    mdiCached,
    mdiMinus,
    mdiPalette,
    mdiPostageStamp,
    mdiBullhorn,
    mdiFormatHeader1,
    mdiCardText,
    mdiAccountSwitchOutline,
    mdiAccountConvert,
    mdiAlphaPBox,
    mdiCardAccountPhone,
    mdiAccountCheck,
    mdiCalendarPlus,
    mdiTools,
    mdiCardsHeart,
    mdiMusicCircleOutline,
    mdiStarCheck,
    mdiHumanHandsup,
    mdiShareVariant,
    mdiStarCircle,
    mdiShieldRemove,
    mdiArrowLeftCircle,
    mdiArrowRightCircle,
    mdiFilePdfBox,
    mdiCreditCardCheck,
    mdiBellRing,
    mdiShieldAlert,
    mdiArrowLeftThin,
    mdiArrowRightThin,
    mdiArrowDownBold,
    mdiHelpCircleOutline,
    //mdi-cash, mdi-arrow-left-circle
  } from '@mdi/js'

  export default {
    name: 'Icono',
    props: {
      icon: String,
      size: Number,
    },
    components: {
      SvgIcon
    },
    data() {
      return {
        iconos: [
          {'name': 'mdiSitemap', 'value': mdiSitemap}, 
          {'name': 'mdiCreditCardCheck', 'value': mdiCreditCardCheck}, // tarjeta de credito
          {'name': 'mdiShieldHalfFull', 'value': mdiShieldHalfFull},
          {'name': 'mdiLan', 'value': mdiLan},
          {'name': 'mdiSealVariant', 'value': mdiSealVariant},
          {'name': 'mdiAccountGroup', 'value': mdiAccountGroup}, // users, usuarios
          {'name': 'mdiFacebook', 'value': mdiFacebook},
          {'name': 'mdiTwitter', 'value': mdiTwitter},
          {'name': 'mdiInstagram', 'value': mdiInstagram},
          {'name': 'mdiSendCircle', 'value': mdiSendCircle}, // telegram
          {'name': 'mdiWhatsapp', 'value': mdiWhatsapp}, // 
          {'name': 'mdiYoutube', 'value': mdiYoutube},
          {'name': 'mdiSearchWeb', 'value': mdiSearchWeb},
          {'name': 'mdiMenu', 'value': mdiMenu},
          {'name': 'mdiShieldOutline', 'value': mdiShieldOutline}, // equipo de futbol
          {'name': 'mdiSoccer', 'value': mdiSoccer}, // balon de futbol
          {'name': 'mdiSoccerField', 'value': mdiSoccerField}, // cancha de futbol
          {'name': 'mdiScoreboardOutline', 'value': mdiScoreboardOutline}, // score, resultado
          {'name': 'mdiWhistle', 'value': mdiWhistle}, // silbato
          {'name': 'mdiStore', 'value': mdiStore}, // tienda
          {'name': 'mdiLoginVariant', 'value': mdiLoginVariant},
          {'name': 'mdiTournament', 'value': mdiTournament}, // llaves de torneo
          {'name': 'mdiTrophy', 'value': mdiTrophy}, // trofeo oscuro
          {'name': 'mdiTrophyOutline', 'value': mdiTrophyOutline}, // trofeo claro
          {'name': 'mdiGoogleMaps', 'value': mdiGoogleMaps},
          {'name': 'mdiGoogle', 'value': mdiGoogle},
          {'name': 'mdiTrophyAward', 'value': mdiTrophyAward}, // trofeo estrella
          {'name': 'mdiInformationOutline', 'value': mdiInformationOutline}, // informacion
          {'name': 'mdiNewspaper', 'value': mdiNewspaper},
          {'name': 'mdiCalendar', 'value': mdiCalendar}, // calendatrio
          {'name': 'mdiCalendarEnd', 'value': mdiCalendarEnd}, // calendario fin
          {'name': 'mdiCalendarStar', 'value': mdiCalendarStar}, // dias
          {'name': 'mdiClockOutline', 'value': mdiClockOutline}, // reloj
          {'name': 'mdiOrderNumericDescending', 'value': mdiOrderNumericDescending},
          {'name': 'mdiSquare', 'value': mdiSquare},
          {'name': 'mdiContentCopy', 'value': mdiContentCopy}, // doble tajreta
          {'name': 'mdiTimerOutline', 'value': mdiTimerOutline}, // reloc de pulso
          {'name': 'mdiHomeCircleOutline', 'value': mdiHomeCircleOutline},
          {'name': 'mdiLaptop', 'value': mdiLaptop}, //laptop
          {'name': 'mdiCash', 'value': mdiCash}, // cash, dinero. moneda, dolar
          {'name': 'mdiToggleSwitchOffOutline', 'value': mdiToggleSwitchOffOutline}, // prendido / apagado // bool
          {'name': 'mdiCloseCircleOutline', 'value': mdiCloseCircleOutline}, // close cerrar
          {'name': 'mdiSettingsHelper', 'value': mdiSettingsHelper}, // settings helper
          {'name': 'mdiChevronDownBoxOutline', 'value': mdiChevronDownBoxOutline}, // abajo
          {'name': 'mdiArrowRightThick', 'value': mdiArrowRightThick}, // flecha derecha
          {'name': 'mdiArrowLeftThick', 'value': mdiArrowLeftThick}, //mdi-arrow-left-thick
          {'name': 'mdiGenderMaleFemaleVariant', 'value': mdiGenderMaleFemaleVariant}, // todos los generos
          {'name': 'mdiCalendarLock', 'value': mdiCalendarLock}, // cerrado
          {'name': 'mdiCalendarToday', 'value': mdiCalendarToday}, // cerrado
          {'name': 'mdiLock', 'value': mdiLock}, // candado
          {'name': 'mdiEmail', 'value': mdiEmail}, // correo
          {'name': 'mdiFormSelect', 'value': mdiFormSelect}, // form select
          {'name': 'mdiCardAccountDetails', 'value': mdiCardAccountDetails}, // card usuario
          {'name': 'mdiPlus', 'value': mdiPlus}, // mas, more, plus
          {'name': 'mdiNewspaperVariantOutline', 'value': mdiNewspaperVariantOutline}, // news noticia
          {'name': 'mdiBookEditOutline', 'value': mdiBookEditOutline}, // book, edit, news
          {'name': 'mdiWeb', 'value': mdiWeb}, // web mundo
          {'name': 'mdiTableCog', 'value': mdiTableCog}, // tabla configuracion
          {'name': 'mdiTableCheck', 'value': mdiTableCheck}, // tabla check
          {'name': 'mdiContentSave', 'value': mdiContentSave}, // tabla check
          {'name': 'mdiDelete', 'value': mdiDelete}, // eliminar - delete
          {'name': 'mdiTshirtCrew', 'value': mdiTshirtCrew}, // camiseta
          {'name': 'mdiRectangle', 'value': mdiRectangle}, // tarjeta - rectangulo
          {'name': 'mdiCached', 'value': mdiCached}, // cambio
          {'name': 'mdiMinus', 'value': mdiMinus}, // cambio
          {'name': 'mdiPalette', 'value': mdiPalette}, // paint. reporte. dibujo
          {'name': 'mdiPostageStamp', 'value': mdiPostageStamp}, // poster imagen
          {'name': 'mdiBullhorn', 'value': mdiBullhorn}, // megafono
          {'name': 'mdiFormatHeader1', 'value': mdiFormatHeader1}, // titutlo h1
          {'name': 'mdiCardText', 'value': mdiCardText}, // texto, subtitulo
          {'name': 'mdiAccountSwitchOutline', 'value': mdiAccountSwitchOutline}, // cambio, de persona
          {'name': 'mdiAccountConvert', 'value': mdiAccountConvert}, // player, cambio, jugador
          {'name': 'mdiAlphaPBox', 'value': mdiAlphaPBox}, //
          {'name': 'mdiCardAccountPhone', 'value': mdiCardAccountPhone}, // telefono
          {'name': 'mdiAccountCheck', 'value': mdiAccountCheck}, // persona, usuario check, usernmae
          {'name': 'mdiCalendarPlus', 'value': mdiCalendarPlus}, // persona, usuario check, usernmae
          {'name': 'mdiTools', 'value': mdiTools}, // herramientas
          {'name': 'mdiCardsHeart', 'value': mdiCardsHeart}, // corazon
          {'name': 'mdiMusicCircleOutline', 'value': mdiMusicCircleOutline}, // musica - tiktok
          {'name': 'mdiStarCheck', 'value': mdiStarCheck}, // estrella - mejor jugador
          {'name': 'mdiHumanHandsup', 'value': mdiHumanHandsup}, // player - festejo- jugador
          {'name': 'mdiShareVariant', 'value': mdiShareVariant}, // player - festejo- jugador
          {'name': 'mdiStarCircle', 'value': mdiStarCircle}, // estrella
          {'name': 'mdiShieldRemove', 'value': mdiShieldRemove}, // equipo eliminado
          {'name': 'mdiArrowLeftCircle', 'value': mdiArrowLeftCircle}, // izquiera flecha
          {'name': 'mdiArrowRightCircle', 'value': mdiArrowRightCircle}, // izquiera flecha
          {'name': 'mdiFilePdfBox', 'value': mdiFilePdfBox}, // pdf
          {'name': 'mdiBellRing', 'value': mdiBellRing}, // notificaciones
          {'name': 'mdiShieldAlert', 'value': mdiShieldAlert}, // notificaciones
          {'name': 'mdiArrowLeftThin', 'value': mdiArrowLeftThin}, // flecha iz
          {'name': 'mdiArrowRightThin', 'value': mdiArrowRightThin}, // flecha der
          {'name': 'mdiArrowDownBold', 'value': mdiArrowDownBold}, // flecha abajo
          {'name': 'mdiHelpCircleOutline', 'value': mdiHelpCircleOutline}, // ayuda, help
        ]
      }
    },
    computed: {
      getIcon: function () {
        const icono = this.iconos.find(
          element => element.name === this.icon
        )
        return icono.value
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>